import { ClosingBand } from "../../../../patterns/ClosingBand.js";
import { ActionButton } from "../../../shared/ActionButton.js";
import type { ClosingContent } from "../../homeContent.js";

/** The closing band: one last headline and the brand action. */
export function HomeClosing(closing: ClosingContent) {
  return (
    <ClosingBand
      title={closing.title}
      body={closing.body}
      media={closing.media}
      action={<ActionButton action={closing.action} variant="brand" size="lg" />}
    />
  );
}
